import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProviderName } from '../../../account/models/login-response.model';
import { config } from '../../../shared/config';
import { ApiService } from '../../../shared/services/core/api.service';
import { LoggingService } from '../../../shared/services/core/logging.service';
import { FidelCallBack } from './fidelcallback.interface';
import { FidelSettings } from './models/fidel-settings.model';
import { FidelLinkedCardError } from './models/fidellinkedcarderror.model';
import { LinkedCard } from './models/linkedcard.model';
import { LinkedOffer } from './models/linkedoffer.model';
declare var Fidel: any;

@Injectable({
  providedIn: 'root',
})
export class FidelService {
  public settings: FidelSettings;

  /**
   * Create a instance of the fidel integration
   */
  constructor(private api: ApiService, private logService: LoggingService) {
    if (this.settings === undefined) {
      let FidelConfig = config.providerSettings.find((x) => x.providerId === ProviderName.Fidel);
      if (FidelConfig != undefined && FidelConfig.settings != undefined) {
        this.settings = FidelConfig.settings as FidelSettings;
      }
    }

    if (this.settings.ProgramId == undefined) {
      this.logService.warning('program set is currently not in the config file');
    }
  }

  /**
   * Invoke the link card process on fidel so the customer can attach their card
   *
   * @param memberId the member of the customer, used to mark the card in fidel to be used to retrive the information
   * @param custom this allows the developer to overwrite the styling. https://fidel.uk/docs/web-sdk/v3
   * @param callbacks holds the success and failed callback when linking a card
   */
  linkcard(memberId: string, custom: any = {}, countries: string[], callbacks: FidelCallBack | undefined = undefined) {
    if (memberId.length <= 5) {
      let fillNumber = 5 - memberId.length;
      for (var i = 0; i < fillNumber; i++) {
        memberId = '0' + memberId;
      }
    }

    Fidel.openForm({
      companyName: 'Fortress',
      sdkKey: this.settings.SdkKey,
      programId: this.settings.ProgramId,
      metadata: {
        id: memberId,
        applicationId: this.settings.ApplicationId,
      },
      custom,
      countries: countries,
      callback() {
        if (arguments.length == 1) {
          // failed response
          if (callbacks != undefined) {
            callbacks.callbackFailed(arguments[0] as FidelLinkedCardError);
          }
        } else {
          // card linked
          if (callbacks != undefined) {
            callbacks.callbackSuccess(arguments[1] as LinkedCard);
          }
        }
      },
    });
  }

  /**
   * Deletes the card from fidel
   *
   * @param cardId the fidel card unique identifier
   *
   * @returns success if completed with no errors
   * */
  deletecard(cardId: string): Observable<any> {
    return this.api.delete(`provider/63/deletelinkedcards`, cardId);
  }

  /**
   * Get the cards from fidel
   *
   * @returns A list of cards for the current customer
   */
  getcards(): Observable<LinkedCard[]> {
    return this.api.get(`provider/63/getlinkedcards`);
  }

  /**
   * Will get all the offers for the current customer
   *
   * @param cardId the fidel card unique identifier (if no card pass in 'card')
   *
   * @returns all the offers
   */
  getOffers(cardId: string): Observable<LinkedOffer[]> {
    return this.api.get(`provider/63/getlinkedoffers/${cardId}`);
  }
}
